export interface SocialPlatformData {
  name: string;
  url: string;
  icon: string;
}
export const ecomotiveSocialPlatforms: Array<SocialPlatformData> = [
  { icon: require('@/assets/Insta.svg'), name: 'Instagram logo', url: 'https://www.instagram.com/terpaysdelaloire/?hl=fr' },
  { icon: require('@/assets/Fb.svg'), name: 'Facebook logo', url: 'https://www.facebook.com/TERPaysdelaLoire/' },
];
export const ecomotivePubsPlatforms: Array<SocialPlatformData> = [
  { icon: require('@/assets/ecomotiv/aleop-v2.webp'), name: 'Companies logo', url: 'https://aleop.paysdelaloire.fr/' },
];
